/* Mobilia – Ice Touch v19: prezzo nel pulsante, strati, mappa, 30 notti, barra fissa, cuscino 3D */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function each(sel, root, fn) { Array.prototype.forEach.call((root || document).querySelectorAll(sel), fn); }
  function clamp(x, a, b) { return Math.max(a, Math.min(b, x)); }
  function eIO(x) { return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; }
  function eOut(x) { return 1 - Math.pow(1 - x, 3); }
  function eBack(x) { var c1 = 1.70158, c3 = c1 + 1; return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2); }
  function onVisible(el, fn, margin) {
    if (!('IntersectionObserver' in window)) { fn(); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { io.disconnect(); fn(); } });
    }, { rootMargin: margin || '0px 0px -15% 0px' });
    io.observe(el);
  }

  /* prezzo nel pulsante quando si sceglie 1 o 2 cuscini */
  function buy(root) {
    each('[data-mi-buy]', root, function (f) {
      var out = f.querySelector('[data-mi-price]');
      f.addEventListener('change', function (e) {
        var t = e.target;
        if (t && t.name === 'id' && out) { out.textContent = t.getAttribute('data-p'); }
      });
    });
  }

  /* strati che si separano mentre si scorre */
  function layers(root) {
    var sec = root.querySelector('[data-layers]'); if (!sec) return;
    var st = sec.querySelector('.mi-stack'); if (!st) return;
    if (reduce) { st.style.setProperty('--sep', '1'); return; }
    var ticking = false, active = true;
    function upd() {
      ticking = false;
      var r = sec.getBoundingClientRect(), vh = window.innerHeight || 800;
      var p = clamp((vh * 0.9 - r.top) / (r.height * 0.55), 0, 1);
      st.style.setProperty('--sep', eIO(p).toFixed(3));
    }
    function onScroll() { if (!ticking && active) { ticking = true; requestAnimationFrame(upd); } }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { active = en[0].isIntersecting; if (active) onScroll(); }, { rootMargin: '120px 0px' }).observe(sec);
    }
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll);
    upd();
  }

  /* mappa: spedizioni da Montescaglioso */
  var ITA = [[7.6,43.79],[8.95,44.41],[9.83,44.1],[10.31,43.55],[10.52,42.93],[11.21,42.44],[11.8,42.09],[12.29,41.73],[12.63,41.45],[13.25,41.28],[13.57,41.21],[14.25,40.84],[14.33,40.6],[14.77,40.68],[14.99,40.35],[15.27,40.03],[15.63,40.07],[15.78,39.9],[16.04,39.36],[16.15,38.9],[15.89,38.68],[15.85,38.36],[15.65,38.11],[15.75,37.92],[16.06,37.93],[16.55,38.69],[17.1,38.9],[17.13,39.08],[17.15,39.38],[16.5,39.75],[16.68,40.2],[17.24,40.47],[17.89,40.26],[17.99,40.06],[18.36,39.8],[18.49,40.15],[17.95,40.64],[17.3,40.95],[16.87,41.13],[16.28,41.32],[15.92,41.63],[16.18,41.88],[15.88,41.93],[14.99,42.0],[14.71,42.12],[14.21,42.46],[13.88,42.95],[13.52,43.62],[12.91,43.91],[12.57,44.06],[12.28,44.42],[12.53,44.95],[12.28,45.22],[12.33,45.44],[12.89,45.6],[13.77,45.65],[13.62,45.95],[13.58,46.5],[12.4,46.7],[11.5,47.0],[10.5,46.85],[10.1,46.6],[9.4,46.4],[8.8,46.2],[7.85,45.92],[6.86,45.83],[6.92,45.2],[7.05,44.68],[7.55,44.15]];
  var SIC = [[15.55,38.19],[15.65,38.27],[15.24,38.22],[14.02,38.04],[13.36,38.12],[12.73,38.18],[12.51,38.02],[12.44,37.8],[12.59,37.65],[13.08,37.51],[13.58,37.27],[14.25,37.06],[14.85,36.73],[15.13,36.69],[15.29,37.07],[15.22,37.23],[15.09,37.5],[15.29,37.85]];
  var SAR = [[9.19,41.24],[9.5,40.92],[9.69,40.57],[9.71,40.38],[9.7,39.93],[9.58,39.42],[9.52,39.14],[9.11,39.21],[8.98,38.98],[8.75,38.88],[8.4,39.05],[8.53,39.9],[8.47,40.3],[8.31,40.56],[8.16,40.56],[8.22,40.94],[8.71,40.91]];
  var CITIES = [[9.19,45.46],[7.69,45.07],[12.33,45.44],[11.34,44.49],[11.25,43.77],[12.5,41.9],[14.27,40.85],[16.87,41.12],[14.21,42.46],[8.93,44.41],[13.36,38.12],[15.09,37.5],[9.11,39.22]];
  var MS = [16.67, 40.55];
  function inPoly(x, y, poly) {
    var c = false;
    for (var i = 0, j = poly.length - 1; i < poly.length; j = i++) {
      var xi = poly[i][0], yi = poly[i][1], xj = poly[j][0], yj = poly[j][1];
      if (((yi > y) !== (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi)) c = !c;
    }
    return c;
  }
  function qpt(a, c, b, u) { return [(1 - u) * (1 - u) * a[0] + 2 * (1 - u) * u * c[0] + u * u * b[0], (1 - u) * (1 - u) * a[1] + 2 * (1 - u) * u * c[1] + u * u * b[1]]; }
  function map(root) {
    var sec = root.querySelector('[data-map]'); if (!sec) return;
    var cv = sec.querySelector('canvas'); if (!cv || !cv.getContext) return;
    var label = cv.getAttribute('data-origin') || 'Montescaglioso';
    var W, H, g, dots, routes, msP, R, started = false, t0 = 0, done = false;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    function setup() {
      W = cv.clientWidth; if (!W) return false;
      H = Math.round(W * 1.1);
      cv.style.height = H + 'px';
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      g = cv.getContext('2d'); g.setTransform(dpr, 0, 0, dpr, 0, 0);
      var CK = Math.cos(42 * Math.PI / 180);
      var minX = 6.6 * CK, maxX = 18.6 * CK, minY = -47.1, maxY = -36.6, pad = W * 0.05;
      var s = Math.min((W - 2 * pad) / (maxX - minX), (H - 2 * pad) / (maxY - minY));
      var ox = (W - (maxX - minX) * s) / 2, oy = (H - (maxY - minY) * s) / 2;
      var P = function (p) { return [ox + (p[0] * CK - minX) * s, oy + (-p[1] - minY) * s]; };
      var polys = [ITA, SIC, SAR].map(function (p) { return p.map(P); });
      var step = Math.max(7, W / 62);
      R = W / 600;
      dots = [];
      for (var y = step / 2; y < H; y += step) for (var x = step / 2; x < W; x += step) {
        if (polys.some(function (p) { return inPoly(x, y, p); })) dots.push([x, y]);
      }
      msP = P(MS);
      routes = CITIES.map(function (c, i) {
        var e = P(c), mx = (msP[0] + e[0]) / 2, my = (msP[1] + e[1]) / 2, dx = e[0] - msP[0], dy = e[1] - msP[1], L = Math.hypot(dx, dy) || 1;
        var nx = -dy / L, ny = dx / L, bend = Math.min(W * 0.24, L * 0.35) * (ny > 0 ? -1 : 1);
        return { c: e, ctl: [mx + nx * bend, my + ny * bend], start: 0.9 + i * 0.12 };
      });
      return true;
    }
    function draw(t) {
      g.clearRect(0, 0, W, H);
      var appear = clamp(t / 0.9, 0, 1), maxD = W * 1.2;
      for (var i = 0; i < dots.length; i++) {
        var d = Math.hypot(dots[i][0] - msP[0], dots[i][1] - msP[1]);
        var wv = clamp(appear * 1.25 - d / maxD, 0, 1); if (wv <= 0) continue;
        g.fillStyle = 'rgba(127,214,255,' + (0.14 + 0.4 * wv).toFixed(3) + ')';
        g.beginPath(); g.arc(dots[i][0], dots[i][1], 2.2 * R + 0.6, 0, 6.283); g.fill();
      }
      g.lineCap = 'round';
      routes.forEach(function (r) {
        var u = eIO(clamp((t - r.start) / 0.9, 0, 1)); if (u <= 0) return;
        g.save(); g.shadowColor = 'rgba(255,181,71,.9)'; g.shadowBlur = 12 * R + 4; g.strokeStyle = 'rgba(255,190,90,.95)'; g.lineWidth = 1.6 * R + 0.8;
        g.beginPath();
        for (var k = 0; k <= 40 * u; k++) { var p = qpt(msP, r.ctl, r.c, k / 40); if (k) g.lineTo(p[0], p[1]); else g.moveTo(p[0], p[1]); }
        g.stroke(); g.restore();
        if (u < 1) {
          var hp = qpt(msP, r.ctl, r.c, u);
          g.save(); g.shadowColor = '#fff'; g.shadowBlur = 14; g.fillStyle = '#fff'; g.beginPath(); g.arc(hp[0], hp[1], 3 * R + 1, 0, 6.283); g.fill(); g.restore();
        }
        var land = clamp((t - r.start - 0.9) / 0.6, 0, 1);
        if (land > 0 && land < 1) { g.strokeStyle = 'rgba(127,214,255,' + (1 - land).toFixed(3) + ')'; g.lineWidth = 1.5; g.beginPath(); g.arc(r.c[0], r.c[1], 5 * R + 20 * R * land, 0, 6.283); g.stroke(); }
        if (u >= 1) { g.fillStyle = 'rgba(127,214,255,.95)'; g.beginPath(); g.arc(r.c[0], r.c[1], 3.2 * R + 0.8, 0, 6.283); g.fill(); }
      });
      var pin = eBack(clamp((t - 0.3) / 0.45, 0, 1));
      if (pin > 0) {
        g.save(); g.shadowColor = 'rgba(255,181,71,1)'; g.shadowBlur = 22; g.fillStyle = '#FFB547';
        g.beginPath(); g.arc(msP[0], msP[1], Math.max(0, (6.5 * R + 2) * pin), 0, 6.283); g.fill(); g.restore();
        g.fillStyle = 'rgba(255,228,190,' + clamp(pin, 0, 1).toFixed(3) + ')';
        g.font = '600 ' + Math.round(Math.max(12, 15 * R + 4)) + 'px Inter, system-ui, sans-serif';
        g.textAlign = 'right'; g.fillText(label, msP[0] - 14 * R - 6, msP[1] + 26 * R + 10); g.textAlign = 'left';
      }
    }
    var END = 0.9 + 12 * 0.12 + 1.6;
    function frame(ts) {
      if (!t0) t0 = ts;
      var t = (ts - t0) / 1000;
      if (t >= END) { done = true; draw(99); return; }
      draw(t); requestAnimationFrame(frame);
    }
    function start() {
      if (started) return; started = true;
      if (!setup()) return;
      if (reduce) { done = true; draw(99); return; }
      requestAnimationFrame(frame);
    }
    window.addEventListener('resize', function () {
      if (!started) return;
      var w = cv.clientWidth; if (!w || Math.abs(w - W) < 2) return;
      if (setup() && done) draw(99);
    });
    onVisible(sec.querySelector('.mi-map') || cv, start, '0px 0px -20% 0px');
  }

  /* 30 notti: il numero conta e le lune si accendono */
  function nights(root) {
    var sec = root.querySelector('[data-nights]'); if (!sec || reduce) return;
    var num = sec.querySelector('[data-count]');
    sec.classList.add('is-wait');
    onVisible(sec.querySelector('.mi-moons') || sec, function () {
      sec.classList.remove('is-wait'); sec.classList.add('is-on');
      if (!num) return;
      var t0 = 0;
      function step(ts) {
        if (!t0) t0 = ts;
        var p = Math.min(1, (ts - t0) / 1500);
        num.textContent = Math.max(1, Math.round(30 * eOut(p)));
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }, '0px 0px -25% 0px');
  }

  /* barra fissa sul telefono, dopo il box di acquisto in alto */
  function sbar(root) {
    var bar = root.querySelector('[data-sbar]'); var top = root.querySelector('.mi-hero [data-mi-buy]');
    if (!bar || !top || !('IntersectionObserver' in window)) return;
    var past = false, others = new Set();
    function upd() {
      var show = past && others.size === 0;
      bar.hidden = false;
      bar.classList.toggle('is-on', show);
      document.documentElement.classList.toggle('mi-sbar-on', show);
    }
    new IntersectionObserver(function (en) {
      var e = en[0]; past = !e.isIntersecting && e.boundingClientRect.top < 0;
      document.documentElement.classList.toggle('mi-top', e.isIntersecting); upd();
    }).observe(top);
    var tg = [root.querySelector('.mi-end'), root.querySelector('.mi-pair form'), document.querySelector('footer')].filter(Boolean);
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) others.add(x.target); else others.delete(x.target); });
      upd();
    });
    tg.forEach(function (t) { io.observe(t); });
  }

  /* cuscino 3D interattivo (motore mobilia-ice3d.js) */
  function stage(root) {
    var st = root.querySelector('[data-ice3d]'); if (!st) return;
    var ar = root.querySelector('.mi-ar');
    if (ar) {
      var ta = document.createElement('a'); var ios = !!(ta.relList && ta.relList.supports && ta.relList.supports('ar'));
      var android = /android/i.test(navigator.userAgent);
      if ((ios && ar.getAttribute('data-usdz')) || (android && ar.getAttribute('data-glb'))) {
        ar.hidden = false;
        ar.addEventListener('click', function () {
          if (ios) { var a = document.createElement('a'); a.setAttribute('rel', 'ar'); a.href = ar.getAttribute('data-usdz') + '#allowsContentScaling=0'; a.appendChild(document.createElement('img')); document.body.appendChild(a); a.click(); setTimeout(function () { a.remove(); }, 1000); }
          else { location.href = 'intent://arvr.google.com/scene-viewer/1.2?file=' + encodeURIComponent(ar.getAttribute('data-glb')) + '&mode=ar_preferred&title=' + encodeURIComponent('Ice Touch') + '#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=' + encodeURIComponent(location.href) + ';end;'; }
        });
      }
    }
    var cv = st.querySelector('canvas'); var ctl = root.querySelector('.mi-stage-ctl');
    var test = document.createElement('canvas'); var ok = !!(test.getContext && test.getContext('webgl2'));
    if (!ok || !st.getAttribute('data-top')) { if (ctl) each('[data-ice-mode]', ctl, function (b) { b.hidden = true; }); return; }
    function boot() {
      if (!window.IceTouch3D) return;
      var E = window.IceTouch3D.create(cv, { tex: { top: st.getAttribute('data-top'), topN: st.getAttribute('data-topn'), gus: st.getAttribute('data-gus'), gusN: st.getAttribute('data-gusn') } });
      if (!E) return;
      var base = { az: -24, el: 22, dist: 1.75, fov: 28 }; Object.assign(E.cam, base);
      var visible = true, running = false, last = 0, t0 = performance.now(), idleUntil = 0, xrOn = false;
      var pressing = false, dragging = false, lastDent = null, lx = 0, ly = 0, touched = false;
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      function size() { var r = st.getBoundingClientRect(); if (r.width < 2) return; E.resize(r.width, r.height, dpr); }
      size();
      if ('ResizeObserver' in window) { new ResizeObserver(function () { size(); kick(); }).observe(st); }
      var cos = st.querySelectorAll('.mi-co'); var anchors = { cover: [0.2, 0.085, 0.12], core: [-0.14, 0.02, 0.1] };
      function place() {
        Array.prototype.forEach.call(cos, function (c) { var a = anchors[c.getAttribute('data-co')]; var p = E.project(a[0], a[1] + E.lift, a[2]); if (p) { c.style.left = p.x + 'px'; c.style.top = p.y + 'px'; } });
      }
      var lastDraw = 0;
      function frame(now) {
        running = false; if (!visible) return;
        var busy = E.isAnimating() || dragging || pressing || Math.abs(E.xray - (xrOn ? 1 : 0)) > 0.001;
        if (!busy && !reduce && now - lastDraw < 32) { running = true; requestAnimationFrame(frame); return; }
        lastDraw = now;
        var dt = Math.min(0.05, (now - (last || now)) / 1000); last = now;
        var t = (now - t0) / 1000;
        if (!reduce && now > idleUntil) { E.cam.az = base.az + 9 * Math.sin(t * 0.35); E.lift = 0.008 * Math.sin(t * 0.9); }
        var target = xrOn ? 1 : 0;
        if (Math.abs(E.xray - target) > 0.001) { E.xray += (target - E.xray) * (1 - Math.exp(-dt / 0.25)); if (Math.abs(E.xray - target) < 0.002) E.xray = target; }
        E.step(dt); E.draw(); if (xrOn || E.xray > 0.01) place();
        if (!reduce || E.isAnimating() || Math.abs(E.xray - target) > 0.001 || dragging || pressing) { running = true; requestAnimationFrame(frame); }
      }
      function kick() { if (!running && visible) { running = true; last = 0; requestAnimationFrame(frame); } }
      if ('IntersectionObserver' in window) { new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible) kick(); }).observe(st); }
      document.addEventListener('visibilitychange', function () { visible = !document.hidden; if (visible) kick(); });
      E.ready.then(function () { size(); E.draw(); st.classList.add('is-live', 'is-press'); kick(); }).catch(function () {});
      function local(e) { var r = cv.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; }
      cv.addEventListener('pointerdown', function (e) {
        var q = local(e); var hit = E.pick(q.x, q.y); idleUntil = performance.now() + 4000;
        if (!touched) { touched = true; st.classList.add('is-touched'); }
        if (hit) { pressing = true; lastDent = E.addDent(hit.x, hit.z, { held: true }); } else { dragging = true; }
        lx = e.clientX; ly = e.clientY; try { cv.setPointerCapture(e.pointerId); } catch (_) {}
        kick();
      });
      cv.addEventListener('pointermove', function (e) {
        if (!pressing && !dragging) return; idleUntil = performance.now() + 4000;
        if (dragging) { E.cam.az -= (e.clientX - lx) * 0.35; base.az = E.cam.az; E.cam.el = Math.max(8, Math.min(60, E.cam.el + (e.clientY - ly) * 0.25)); lx = e.clientX; ly = e.clientY; }
        else {
          var q = local(e); var hit = E.pick(q.x, q.y);
          if (hit && lastDent) { var d = Math.hypot(hit.x - lastDent.x, hit.z - lastDent.z); if (d > 0.025) { lastDent.held = false; lastDent = E.addDent(hit.x, hit.z, { held: true }); } }
          else if (!hit && lastDent) { lastDent.held = false; lastDent = null; }
        }
        kick();
      });
      function up() { if (pressing) { E.releaseAll(); } pressing = false; dragging = false; lastDent = null; kick(); }
      cv.addEventListener('pointerup', up); cv.addEventListener('pointercancel', up); cv.addEventListener('lostpointercapture', up);
      if (ctl) {
        ctl.addEventListener('click', function (e) {
          var b = e.target.closest('[data-ice-mode]'); if (!b) return; var m = b.getAttribute('data-ice-mode');
          if (m === 'xray') { xrOn = !xrOn; b.classList.toggle('is-on', xrOn); b.setAttribute('aria-pressed', xrOn ? 'true' : 'false'); st.classList.toggle('is-xray', xrOn); }
          else {
            if (xrOn) { xrOn = false; var xb = ctl.querySelector('[data-ice-mode=xray]'); if (xb) { xb.classList.remove('is-on'); xb.setAttribute('aria-pressed', 'false'); } st.classList.remove('is-xray'); }
            var hit = E.addDent(0.05, 0.0, { held: false, depth: 0.0 }); hit.held = true; setTimeout(function () { hit.held = false; kick(); }, 650);
          }
          idleUntil = performance.now() + 3000; kick();
        });
      }
    }
    var jsOn = false;
    function loadJs() {
      if (jsOn) return; jsOn = true;
      if (window.IceTouch3D) { boot(); return; }
      var s = document.createElement('script'); s.src = st.getAttribute('data-js'); s.async = true; s.onload = boot; document.head.appendChild(s);
    }
    st.addEventListener('pointerdown', loadJs); if (ctl) { ctl.addEventListener('click', loadJs); }
    var cn = navigator.connection, slow = !!(cn && (cn.saveData || /2g|3g/.test(cn.effectiveType || '')));
    function watch() {
      if ('IntersectionObserver' in window) {
        var lo = new IntersectionObserver(function (en) {
          if (en[0].isIntersecting) { lo.disconnect(); if ('requestIdleCallback' in window) { requestIdleCallback(loadJs, { timeout: 2000 }); } else { setTimeout(loadJs, 200); } }
        }, { rootMargin: '300px' });
        lo.observe(st);
      } else { loadJs(); }
    }
    if (!slow) { var later = function () { setTimeout(watch, 1500); }; if (document.readyState === 'complete') { later(); } else { window.addEventListener('load', later); } }
  }

  function init(root) {
    if (root.getAttribute('data-mi-on')) return; root.setAttribute('data-mi-on', '1');
    buy(root); layers(root); map(root); nights(root); sbar(root); stage(root);
  }
  function run() { each('[data-mi]', document, init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); } else { run(); }
  document.addEventListener('shopify:section:load', run);
})();
